import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { WorkspaceSidebarProps } from "./types";
import styles from "./WorkspaceSidebar.module.scss";

const WorkspaceSidebar = ({
  navItems,
  selectedItem,
  onSelect,
  workspaceName,
  workspaceIconSrc,
  workspaceAccentColor = "#55b685",
  showProductSwitcher = false,
  groupIcon,
  isProductDropdownOpen = false,
  productItems = [],
  onProductSwitcherClick,
  onProductSelect,
  onSettingsClick,
  settingsLabel = "Exit",
}: WorkspaceSidebarProps) => {
  const isActive = (url?: string) =>
    Boolean(url && selectedItem && selectedItem === url);

  return (
    <aside className={styles.sidebar}>
      <div className={styles.header}>
        <div className={styles.workspaceHeader}>
          <div
            className={styles.workspaceIcon}
            style={{ backgroundColor: workspaceAccentColor }}
          >
            {workspaceIconSrc ? (
              <img src={workspaceIconSrc} alt={workspaceName} />
            ) : null}
          </div>
          <div className={styles.workspaceMeta}>
            <div className={styles.workspaceLabel}>WORKSPACE</div>
            <div className={styles.workspaceName}>{workspaceName}</div>
          </div>
          {showProductSwitcher ? (
            <button
              type="button"
              className={styles.switcherButton}
              onClick={onProductSwitcherClick}
              aria-label="Switch workspace product"
              aria-expanded={isProductDropdownOpen}
            >
              {groupIcon ?? <UnfoldMoreIcon className={styles.switcherIcon} />}
            </button>
          ) : null}
        </div>

        {isProductDropdownOpen && productItems.length > 0 ? (
          <div className={styles.productDropdown}>
            {productItems.map((item) => (
              <button
                key={item.id}
                type="button"
                className={styles.productItem}
                onClick={() => onProductSelect?.(item)}
              >
                {item.icon ? (
                  <div
                    className={styles.productIcon}
                    style={{ backgroundColor: item.accentColor ?? workspaceAccentColor }}
                  >
                    <img src={item.icon} alt={item.name} />
                  </div>
                ) : null}
                <span>{item.name}</span>
              </button>
            ))}
          </div>
        ) : null}
      </div>

      <nav className={styles.nav}>
        {navItems.map((item) => (
          <button
            key={`${item.id}-${item.url ?? item.label}`}
            type="button"
            className={`${styles.navItem} ${isActive(item.url) ? styles.navItemActive : ""}`}
            onClick={() => item.url && onSelect(item.url)}
          >
            {item.icon ? <span className={styles.navIcon}>{item.icon}</span> : null}
            <span className={styles.navLabel}>{item.label}</span>
          </button>
        ))}
      </nav>

      {onSettingsClick ? (
        <div className={styles.footer}>
          <button
            type="button"
            id="sidebar-logout-btn"
            className={styles.exitButton}
            onClick={onSettingsClick}
          >
            {settingsLabel}
          </button>
        </div>
      ) : null}
    </aside>
  );
};

export default WorkspaceSidebar;
